import { useRecordRecentSearchMutation as e } from "./useRecordRecentSearchMutation.mjs";
import { useIsAuthenticated as t } from "@maat/store-auth";
import { recentSearchSignature as n } from "@maat/api-main/types";
import { useEffect as r, useRef as i } from "react";
//#region src/recentSearches/useRecordRecentSearch.ts
var a = 1500, o = (o, s, c, { debounceMs: l = a } = {}) => {
	let u = t(), { mutate: d } = e(), f = i(/* @__PURE__ */ new Set()), p = i(s);
	p.current = s;
	let m = o, h = s ? n(m, s) : null;
	r(() => {
		if (!u || !h || f.current.has(h)) return;
		let e = setTimeout(() => {
			let e = p.current;
			e && (f.current.add(h), d({
				kind: m,
				platform: c,
				...e
			}));
		}, l);
		return () => clearTimeout(e);
	}, [
		u,
		h,
		m,
		c,
		d,
		l
	]);
};
//#endregion
export { o as useRecordRecentSearch };
